import type { IBrandConfig } from './types';

const ENGUARD_BRAND_CONFIG: IBrandConfig = {
  privacyPolicy: 'https://www.enguard.io/privacy-policy',
  termsOfService: 'https://www.enguard.io/terms-of-service',
  vaultProject: 'enguard',
  adaChat: true,
  accountDetails: true,
  secureUpload: false,
  plan: true,
  security: true,
  missingPII: true,
  finishSetup: true,
  darkwebDashboardCard: true,
  defaultBillingCategoryKey: 'identitydefense_d2c',
  downloadsRecommended: true,
  copyRightText: 'Intersections LLC dba Pango. All rights reserved.',
  hasCustomerServiceSupport: true,
  horizontalVaultDashboardCards: false,
  ssoRedirectURL: null,
  carouselBanners: true,
  dwEmailVerification: {
    adaChat: true,
    signInButton: true,
    supportAt: null,
    availability:
      'Representatives are available Monday - Friday, 8AM-11PM ET and Saturday, 9AM-6PM ET.',
  },
  supportPage: {
    pageTitle: {
      active: true,
      title: 'More ways to reach us',
    },
    customerSupportTitle: {
      active: true,
      title: 'You can reach our customer care team:',
      availability:
        'Customer care representatives are available Monday - Friday, 8AM-11PM ET and Saturday, 9AM-6PM ET.',
    },
    faq: {
      active: true,
    },
    pages: [],
    call: {
      active: true,
      customerSupport: true,
      availability: (
        <>
          Monday - Friday, 8AM-11PM ET <br /> Saturday, 9AM-6PM ET
        </>
      ),
    },
    mail: {
      active: true,
      address: 'PO Box 52330, Boston, MA 02210',
      customerSupport: false,
    },
    email: {
      active: true,
      customerSupport: true,
    },
  },
};

export default ENGUARD_BRAND_CONFIG;
